/*
 * custom-perso-garde-cadeau.js  (v4)  —  les Enfants Sauvages  —  07/10/2026
 * ---------------------------------------------------------------------------
 * GARDE « TROUSSE OFFERTE DÈS 60 € »  (Monster Cart Upsell, palier « add to unlock »)
 *
 * RÔLE : rattraper les paniers où la Trousse Offerte MANQUE (panier ≥ seuil)
 * ou est EN TROP (panier < seuil) parce que Monster n'a pas vu le changement.
 *
 * CE QUE MONSTER FAIT DÉJÀ (mesuré sur le site le 07/10/2026) :
 *   - il ajoute / retire le cadeau à chaque changement de panier qu'il gère ;
 *   - au chargement d'une page, il ajoute le cadeau si le panier repris
 *     dépasse déjà le seuil (onglet neuf).
 *
 * LES TROUS QUE CE SCRIPT BOUCHE :
 *   1. Panier modifié HORS Monster (bouton non capté, autre app…) : Monster ne
 *      voit rien, son tiroir est périmé et sa règle cadeau ne tourne pas.
 *      → on lui demande de se resynchroniser avec SA fonction publique
 *        window.monster_refresh(false) : 1 requête /cart.js, tiroir non ouvert.
 *   2. Cadeau disparu après un premier ajout : Monster note dans l'onglet
 *      (sessionStorage) qu'il l'a « déjà ajouté » et ne le remet plus tant
 *      que le panier reste au-dessus du seuil (même après rechargement).
 *      → on efface ce mémo et on laisse Monster le remettre, 1 fois par
 *        passage au-dessus du seuil ; une 2e disparition est respectée.
 *   3. Monster absent ou modifié par une mise à jour : si, après lui avoir
 *      laissé la main (et jusqu'à 12 s pour se charger), le panier est
 *      toujours incohérent, on écrit la ligne nous-mêmes avec la propriété
 *      _monster_free_gift que Monster reconnaît (sans elle, il supprime la
 *      trousse : son type produit est free_gift). Ce repli est limité à
 *      2 écritures par onglet et s'arrête au premier échec (rupture de stock…) :
 *      un état qu'on n'a pas su corriger n'est plus retenté dans l'onglet.
 *
 * COÛT : AUCUNE requête réseau dans le cas normal (panier vide ou cohérent,
 * changements faits par Monster).
 *   - Au chargement : on lit le panier et la config Monster déjà écrits dans
 *     la page (window.mu_cart_items, window.mu_campaigns).
 *   - Ensuite : on écoute l'événement « cart:updated » que Monster émet avec le
 *     contenu du panier, et on observe passivement (PerformanceObserver) les
 *     requêtes panier faites hors Monster. AUCUN fetch / XHR n'est modifié.
 *   - Réseau seulement si le panier est incohérent : 1 requête pour un
 *     changement fait hors Monster, 3 à 4 pour remettre une trousse disparue,
 *     6 au pire en repli. Plafonds : 3 interventions et 5 resynchros par page.
 *
 * RÈGLE = CELLE DE MONSTER, À L'IDENTIQUE (sinon les deux scripts se battent) :
 *   - montant = somme des line_price de toutes les lignes (réglage Monster
 *     « include_discounts »). Cartes cadeaux et porte-savon COMPTENT : Monster
 *     ne les exclut pas (ses exclude_tags ne filtrent que ses recommandations,
 *     vérifié en direct : 39 € porte-savon + 22 € = trousse ajoutée) ;
 *   - seuil = objectif propre à la devise active s'il existe, sinon objectif
 *     principal (60 €) × Shopify.currency.rate (ex. CHF), arrondi comme Monster ;
 *   - campagne, seuil et produit cadeau sont lus dans la config Monster : si le
 *     seuil change dans Monster, la garde suit sans retouche.
 *
 * SÉCURITÉ / REPLI :
 *   - campagne inactive, plusieurs paliers, cadeau à plusieurs variantes,
 *     palier en quantité, calcul Monster sans « include_discounts » → la garde
 *     se met en retrait (elle ne fait rien) ;
 *   - 1,5 s de calme exigé avant d'agir ET juste avant toute écriture ; panier
 *     relu juste avant d'écrire ; jamais d'ajout si une trousse est déjà là,
 *     même sans la marque Monster ;
 *   - éditeur de thème ignoré ; toute erreur est avalée (panier jamais bloqué).
 *
 * NE COUVRE PAS : commandes d'abonnement Appstle et portail d'abonnement,
 * ajouts post-achat (hors navigateur) ; changements de quantité faits hors
 * Monster via /cart/update.js (non observés, pour ne pas réagir aux mises à
 * jour d'attributs de Monster) : rattrapés au chargement de page suivant.
 *
 * DIAGNOSTIC : dans la console du navigateur,
 *   localStorage.setItem('les_gg_debug', '1')  puis recharger la page
 *   → journal « [garde-cadeau] ».  Arrêt : localStorage.removeItem('les_gg_debug')
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  if (window.__lesGardeCadeau) return;
  window.__lesGardeCadeau = true;
  if (window.Shopify && window.Shopify.designMode) return; // éditeur de thème

  var PROP = '_monster_free_gift';   // marque posée par Monster sur la ligne cadeau
  var FLAG = 'mu_atu_gift_added_';   // mémo d'onglet de Monster « cadeau déjà ajouté »
  var READD_KEY = 'les_gg_readd';    // nos remises sur le passage en cours
  var DIRECT_KEY = 'les_gg_direct';  // nos écritures directes dans cet onglet
  var STUCK_KEY = 'les_gg_stuck';    // état jugé impossible à corriger dans cet onglet
  var SETTLE = 1500;                 // calme laissé à Monster avant de juger (ms)
  var LOAD_WAIT = 4000;              // au chargement, Monster agit vers 3-4 s
  var VERIFY_WAIT = 2500;            // délai laissé à Monster après resynchro
  var MONSTER_GRACE = 12000;         // Monster peut se charger tard (mobile lent)
  var MAX_ACTIONS = 3;               // interventions max par page
  var MAX_SYNCS = 5;                 // resynchros max par page (changements hors Monster)
  var MAX_WAITS = 40;                // reports max par page (Monster occupé)
  var MAX_READD = 1;                 // remises après disparition, par passage ≥ seuil
  var MAX_DIRECT = 2;                // écritures directes max par onglet (repli)
  var MUTATION = /\/cart\/(add|change|clear)(\.js)?(\?|$)/;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var perf = window.performance && window.performance.now ? window.performance : null;
  var cfg = null, timer = null, busy = false, memoBefore = null;
  var actions = 0, syncs = 0, waits = 0, lastEvent = -1e9, ownUntil = -1e9;

  var debug = false;
  try { debug = window.localStorage.getItem('les_gg_debug') === '1'; } catch (e) {}
  function log() {
    if (!debug || !window.console) return;
    var a = Array.prototype.slice.call(arguments);
    a.unshift('[garde-cadeau]');
    console.log.apply(console, a);
  }
  function clock() { return perf ? perf.now() : Date.now(); } // même horloge que les requêtes observées

  /* ---------- Config Monster (déjà présente dans la page) ---------- */
  function readConfig() {
    var camps = window.mu_campaigns, hit = null, count = 0;
    if (!camps || typeof camps !== 'object') return null;
    for (var id in camps) {
      if (!Object.prototype.hasOwnProperty.call(camps, id)) continue;
      var atu = camps[id] && camps[id].add_to_unlock;
      if (!atu || !atu.isActive || !atu.goals || !atu.goals.length) continue;
      for (var i = 0; i < atu.goals.length; i++) {
        var g = atu.goals[i];
        if (g && g.reward_type === 'gift') { count++; hit = { id: id, atu: atu, g: g }; }
      }
    }
    if (count !== 1 || hit.atu.goals.length !== 1) return null;
    if (hit.atu.multi_goal_type && hit.atu.multi_goal_type !== 'amount') return null;
    if (!(hit.atu.include_discounts || window.mu_atu_include_discounts)) return null; // autre calcul Monster
    var prods = (hit.g.gift && hit.g.gift.products) || [];
    var vars = prods.length === 1 && prods[0] && prods[0].variants;
    if (!vars || vars.length !== 1 || !vars[0]) return null;
    var variant = Number(String(vars[0].id).split('/').pop());

    var cur = (window.Shopify && window.Shopify.currency) || {};
    var rate = Number(cur.rate) || 1, list = hit.g.specific_goals || [], own = null, main = null;
    for (var j = 0; j < list.length; j++) { // mêmes choix que Monster : 1re devise trouvée, 1er objectif principal
      if (!list[j]) continue;
      if (!own && list[j].currency === cur.active) own = list[j];
      if (!main && list[j].main === true) main = list[j];
    }
    var goal = own && own.goal ? Number(own.goal) : main ? Number(main.goal) * rate : Number(hit.g.goal) * rate;
    if (!variant || !(goal > 0)) return null;
    return { campaign: String(hit.id), variant: variant, goalIndex: '0', goal: parseInt(goal * 100, 10) };
  }

  /* ---------- Règle (identique à Monster) ---------- */
  function analyse(items) {
    var amount = 0, qty = 0, lines = [], unmarked = false;
    for (var i = 0; i < items.length; i++) {
      var it = items[i] || {};
      var lp = it.line_price;
      if (lp == null) lp = (it.price || 0) * (it.quantity || 0);
      amount += Number(lp) || 0;
      if (Number(it.variant_id) !== cfg.variant) continue;
      var p = it.properties;
      if (p && p[PROP] != null && String(p[PROP]) === cfg.goalIndex) { qty += it.quantity || 0; lines.push(it); }
      else unmarked = true; // trousse présente sans la marque Monster
    }
    var need = amount >= cfg.goal;
    if (!need) resetReadd(); // repassé sous le seuil : nouveau passage
    var state = need ? (qty === 1 ? 'ok' : qty === 0 ? 'manquant' : 'double')
                     : (qty === 0 ? 'ok' : 'en-trop');
    if (state === 'ok') sDel(STUCK_KEY);
    return { state: state, amount: amount, lines: lines, unmarked: unmarked };
  }

  /* ---------- Mémos d'onglet ---------- */
  function sGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function sDel(k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  function monsterKey() { return FLAG + cfg.campaign + ':' + cfg.goalIndex + ':' + cfg.variant; }
  function monsterRemembers() { return sGet(monsterKey()) === '1'; }
  function readdCount() { return Number(sGet(READD_KEY)) || 0; }
  function resetReadd() { sDel(READD_KEY); }
  function respected(a) { return a.state === 'manquant' && monsterRemembers() && readdCount() >= MAX_READD; }
  function stuck(a) { return sGet(STUCK_KEY) === a.state; } // ex. trousse en rupture : on n'insiste pas
  function idle(a) { return respected(a) || stuck(a); }

  /* ---------- Réseau (uniquement en cas d'incohérence) ---------- */
  function wait(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }
  function getCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); });
  }
  function post(path, body) {
    ownUntil = clock() + 4000;
    return fetch(root + path, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(path + ' ' + r.status); return r.json(); });
  }
  function monsterSync() { // Monster relit le panier et rejoue sa règle cadeau, tiroir fermé
    if (typeof window.monster_refresh !== 'function') return Promise.resolve(false);
    ownUntil = clock() + 4000;
    try {
      return Promise.resolve(window.monster_refresh(false))
        .then(function () { return true; }, function () { return false; });
    } catch (e) { return Promise.resolve(false); }
  }
  function write(a) { // repli : écriture directe, reconnue par Monster
    var used = Number(sGet(DIRECT_KEY)) || 0;
    if (used >= MAX_DIRECT || (a.state === 'manquant' && a.unmarked)) {
      log(used >= MAX_DIRECT ? 'repli épuisé pour cet onglet : pas d\'écriture' : 'trousse déjà là sans la marque Monster : pas de doublon');
      sSet(STUCK_KEY, a.state);
      return Promise.resolve();
    }
    sSet(DIRECT_KEY, String(used + 1));
    var req;
    if (a.state === 'manquant') {
      var props = {};
      props[PROP] = cfg.goalIndex;
      req = post('cart/add.js', { items: [{ id: cfg.variant, quantity: 1, properties: props }] })
        .then(function () { sSet(monsterKey(), '1'); }); // comme si Monster l'avait ajoutée
    } else {
      var updates = {};
      for (var i = 0; i < a.lines.length; i++) updates[a.lines[i].key] = (a.state === 'double' && i === 0) ? 1 : 0;
      req = post('cart/update.js', { updates: updates });
      if (a.state === 'en-trop') req = req.then(function () { sDel(monsterKey()); });
    }
    return req.catch(function (e) { sSet(DIRECT_KEY, String(MAX_DIRECT)); sSet(STUCK_KEY, a.state); throw e; }); // échec : repli coupé
  }

  /* ---------- Correction ---------- */
  function schedule(ms, why, expectAdd) {
    clearTimeout(timer);
    // Monster ne pose son mémo qu'APRÈS un ajout réussi : s'il apparaît d'ici la vérification,
    // la trousse a été ajoutée par Monster et on n'a même pas besoin de relire le panier.
    if (expectAdd !== undefined) memoBefore = expectAdd ? monsterRemembers() : null;
    timer = setTimeout(function () { fix(why); }, ms);
  }

  function fix(why) {
    if (!cfg || actions >= MAX_ACTIONS) return;
    var monsterLoading = typeof window.monster_refresh !== 'function' && clock() < MONSTER_GRACE;
    if (busy || monsterLoading || clock() - lastEvent < SETTLE) { // Monster (ou nous) encore au travail
      if (++waits <= MAX_WAITS) schedule(SETTLE, why);
      return;
    }
    if (memoBefore === false && monsterRemembers()) { memoBefore = null; log('Monster a ajouté la trousse lui-même'); return; }
    memoBefore = null;
    busy = true;
    var done = function () { busy = false; };
    try {
      getCart().then(function (cart) {
        var a = analyse(cart.items || []);
        log(why + ' → panier relu : ' + a.state + ' (' + a.amount / 100 + ' / ' + cfg.goal / 100 + ')');
        if (a.state === 'ok') return;
        if (respected(a)) { log('déjà remis une fois sur ce passage : retrait respecté'); return; }
        if (stuck(a)) { log('état déjà jugé impossible à corriger dans cet onglet'); return; }
        actions++;
        if (a.state === 'manquant' && monsterRemembers()) {
          sSet(READD_KEY, String(readdCount() + 1));
          sDel(monsterKey());
          log('mémo Monster « déjà ajouté » effacé');
        }
        return monsterSync().then(function () { return wait(VERIFY_WAIT); }).then(getCart).then(function (cart2) {
          var b = analyse(cart2.items || []);
          if (b.state === 'ok') { log('corrigé par Monster'); return; }
          if (clock() - lastEvent < SETTLE) { log('Monster encore actif : on repousse'); schedule(SETTLE, why); return; }
          log('Monster n\'a pas corrigé (' + b.state + ') → écriture directe');
          return write(b).then(monsterSync);
        });
      }).catch(function (e) { log('erreur', e && e.message); }).then(done, done);
    } catch (e) { done(); }
  }

  /* ---------- Déclencheurs (sans réseau) ---------- */
  function onMonsterCart(e) { // Monster a mis à jour son panier
    try {
      var items = e && e.detail && e.detail.items;
      if (!Array.isArray(items)) return;
      for (var i = 0; i < items.length; i++) if (!items[i] || items[i].variant_id == null) return; // pas un panier Shopify
      lastEvent = clock();
      var a = analyse(items);
      if (a.state === 'ok') { clearTimeout(timer); return; }
      if (idle(a)) return;
      log('cart:updated → ' + a.state + ', vérification dans ' + SETTLE + ' ms');
      schedule(SETTLE, 'cart:updated', a.state === 'manquant');
    } catch (x) {}
  }

  function onOutsideChange(endedAt) { // requête panier terminée à endedAt, vue hors Monster ?
    setTimeout(function () {
      if (lastEvent >= endedAt || syncs >= MAX_SYNCS) return; // Monster l'a traitée lui-même
      syncs++;
      log('panier modifié hors Monster → resynchronisation');
      var expect = !monsterRemembers();
      monsterSync();
      schedule(VERIFY_WAIT, 'hors Monster', expect); // annulé dès que Monster confirme un panier cohérent
    }, SETTLE);
  }

  function watchNetwork() {
    if (!window.PerformanceObserver || !perf) return;
    try {
      new PerformanceObserver(function (list) {
        var es = list.getEntries();
        for (var i = 0; i < es.length; i++) {
          var t = es[i].initiatorType;
          if ((t === 'fetch' || t === 'xmlhttprequest') && MUTATION.test(es[i].name) && es[i].startTime > ownUntil) {
            onOutsideChange(es[i].responseEnd || clock());
            return;
          }
        }
      }).observe({ type: 'resource' });
    } catch (e) {}
  }

  function start() {
    try {
      cfg = readConfig();
      if (!cfg) { log('pas de palier cadeau Monster exploitable → retrait'); return; }
      document.addEventListener('cart:updated', onMonsterCart);
      watchNetwork();
      var a = analyse(Array.isArray(window.mu_cart_items) ? window.mu_cart_items : []);
      log('chargement : ' + a.state + ' (' + a.amount / 100 + ' / ' + cfg.goal / 100 + ', variante ' + cfg.variant + ')');
      if (a.state === 'ok') return;
      if (idle(a)) { log('rien à faire : retrait respecté ou état déjà jugé impossible à corriger'); return; }
      schedule(LOAD_WAIT, 'chargement', a.state === 'manquant');
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
